<template>
  <div class="container-fluid">
   <!-- <div class="card mb-4">
      <div class="card-body">
        <div class="card-header">
          <h5 class="mb-10 mt-3">Filtrer les retours</h5>
        </div>
         <form class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Store :</label>
            <v-select
              v-model="store_filter"
              label="name"
              :options="StoresList"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Statut:</label>
            <select v-model="status_filter" class="form-select">
              <option value="" selected>Status (Tous)</option>
              <option :value="4">Vide</option>
              <option :value="0" selected>Nouveau</option>
              <option :value="1" selected>En attente d'expédition</option>
              <option :value="2">Expédié</option>
              <option :value="3">Reçu</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Statut-Auto/normal:</label>
            <select v-model="status_auto_filter" class="form-select">
              <option value="" selected>Status (Tous)</option>
              <option :value="0" selected>Automatique</option>
              <option :value="1" selected>Normal</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Ville :</label>
            <v-select
              v-model="city_filter"
              label="name"
              :options="CitiesList"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Créer par :</label>
            <v-select
              v-model="user_filter"
              label="name"
              :options="UsersList"
              @search="onSearchUsers"
            >
             
            </v-select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Par Date :</label>
            <rangedate-picker
              id="productid"
              ref="myInput"
              v-model="date_filter"
              format="YYYY-MM-DD"
              i18n="EN"
              :preset-ranges="presetRanges"
              :captions="captions"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Date de validation :</label>
            <rangedate-picker
              ref="myInputValidate"
              v-model="date_filter"
              format="YYYY-MM-DD"
              i18n="EN"
              :preset-ranges="presetRanges"
              :captions="captions"
            />
          </div>
          <div class="col-md-4 d-flex align-items-end">
            <button
              type="button"
              class="btn btn-primary me-2"
              @click="filter()"
            >
              <feather-icon icon="FilterIcon" size="16" />
              Filtrer
            </button>
            <button
              type="button"
              class="btn btn-danger me-2"
              @click="Removefilter()"
            >
              <feather-icon icon="XIcon" size="16" />
              Annuler
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="ExportNotes()"
            >
              <feather-icon icon="FileTextIcon" size="16" />
              Exporter
            </button>
          </div>
        </form> 
      </div>
    </div>-->


    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6 d-flex align-items-center">
            <label class="me-2">Voir</label>
            <v-select
              v-model="users.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="me-2"
              @input="getRecords()"
            />
            <label>sur {{ users.total }} entités</label>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <input
              v-model="searchTerm"
              class="form-control me-2"
              placeholder="Chercher"
              @change="filter()"
              @input="handleInput"
            />
          </div>
        </div>

        <vue-good-table
          :columns="columns"
          :rows="rows"
          responsive
        >
          <template #emptystate>
            <center>Aucune entrées correspondants trouvés</center>
          </template>
          <template v-slot:table-row="props">
            <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
              <b>{{ props.row.note_ref }}</b
              >
            </span>
            <span
              v-else-if="props.column.field === 'for_name'"
              class="text-nowrap"
            >
              <span v-if="props.row.magasin">
                {{ props.row.magasin.market_name }}
              </span>
              ({{ props.row.for_name }})
            </span>
           
            <span
              v-else-if="props.column.field === 'created_at'"
              class="text-nowrap"
            >
              <span v-if="props.row.created_at != null">
                {{ getDate(props.row.created_at) }}
              </span><br/>
              {{ props.row.by_name }}
            </span>
            <span
              v-else-if="props.column.field === 'validate_time'"
              class="text-nowrap"
            >
              <span v-if="props.row.validate_time != null">
                {{ getDate(props.row.validate_time) }}
              </span>
              <template
                v-if="props.row.duration_days && props.row.duration_days != ''"
              >
                {{ numberPars(props.row.duration_days) }} jours
              </template>
            </span>
            <span v-else-if="props.column.field === 'reçu'" class="text-nowrap">
              <h5 v-if="props.row.reçu == 2">1</h5>
              <h5 v-else>0</h5>
            </span>
            <template v-else-if="props.column.field === 'statut'">
              <span
                v-if="props.row.statut == 0"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Nouveau
              </span>
              <span
                v-else-if="props.row.statut == 1"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                En attenete d'expédition
              </span>
              <span
                v-else-if="props.row.statut == 2"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Expédier vers client
              </span>
              <span
                v-else-if="props.row.statut == 3"
                :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                  props.row.statut
                )}`"
                class="text-capitalize"
              >
                Reçu par client
              </span>
            </template>
            <template v-else-if="props.column.field === 'action'">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="GetPDF(props.row)"
                    >
                      <i class="flaticon-download me-1"></i> Télécharger
                    </a>
            </template>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <PaginatorContent
          :pagination="users"
          :offset="9"
          @paginate="getRecords"
        />
      </div>
    </div>
  </div>

</template>


<script lang="ts">
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    // Imports
    // Refs and reactive state
    const isLoader = ref(false);
    const pageLength = ref(10);
    const loading = ref(false);
    const searchTerm = ref("");
    const columns = [
     {
          label: "Référence",
          field: "note_ref",
        },
        {
          label: "Date de création",
          field: "created_at",
        },
        {
          label: "Statut",
          field: "statut",
        },
        // {
        //   label: "Colis",
        //   field: "total_parcel",
        // },
        {
          label: "Actions",
          field: "action",
          width: '180px',

        },
    ];
    const rows = ref([]);
    const ZonesList = ref([]);
    const StoresList = ref([]);
    const zone_filter = ref({ id: "", name: "" });
    const store_filter = ref({ id: "", name: "" });
    const UsersList = ref([]);
    const user_filter = ref({ id: "", name: "" });
    const CitiesList = ref([]);
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const status_auto_filter = ref("");
    const date_filter = ref("");
    const duration = ref("");
    const users = reactive({
      searchTerm: "",
        searchStatut:"",
        searchDate:"",
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 1,
    });
    const offset = ref(9);
    const codeColis = ref("");
    let searchTimeout = null;
    let debounceTimer = null;
    const rowNote = ref({});
    const myInput = ref();
    const myInputValidate = ref();

    // Methods
    function numberPars(x) {
      let sum = parseFloat(x);
      return sum.toFixed(2);
    }

   
   

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0 || status === "0") return "danger";
      if (status === 1 || status === "1") return "info";
      if (status === 2 || status === "2") return "warning";
      if (status === 3 || status === "3") return "success";
      return "warning";
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }


    onMounted(() => {
      getRecords();
    });
    function filter() {
     
      users.searchStatut = status_filter.value;
      users.searchDate= date_filter.value
      users.current_page = 1;
      getRecords();
    }

    function Removefilter() {
      users.searchStatut =
        users.searchTerm =
        users.searchDate = "";
      users.current_page = 1;
      duration.value = "";
      getRecords();
    }

    function handleInput() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users.searchTerm = searchTerm.value;
          filter();
        } else if (searchTerm.value && searchTerm.value.length > 2) {
          users.searchTerm = searchTerm.value;
          filter();
        }
      }, 500);
    }

    function getRecords( page = 1) {
      isLoader.value = true;
      users.current_page = page; // ✅ update the current page
      api
        .get(
          `/api/auth/client/brn_cstmr_list?searchTerm=${users.searchTerm}&searchStatut=${users.searchStatut}&searchDate=${users.searchDate}&page=${users.current_page}&per_page=${users.per_page}`)
        .then((response) => {
          rows.value = response.data.users.data;
          Object.assign(users, response.data.users);
          isLoader.value = false;
        });
    }


    function GetPDF(row: any) {
      api
        .get(`/api/auth/client/returnPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

   

    return {
      isLoader,
      pageLength,
      loading,
      searchTerm,
      columns,
      rows,
      ZonesList,
      StoresList,
      zone_filter,
      store_filter,
      UsersList,
      user_filter,
      CitiesList,
      city_filter,
      status_filter,
      status_auto_filter,
      date_filter,
      duration,
      users,
      offset,
      codeColis,
      rowNote,
      myInput,
      myInputValidate,
      numberPars,
      getDate,
      resolveUserStatusVariant,
      convert,
      filter,
      Removefilter,
      handleInput,
      getRecords,
        GetPDF,
      auth,
        user,
    };
  },
});
</script>